import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=09475832"
import script from "./SortIcon.vue?vue&type=script&lang=ts"
export * from "./SortIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-intelligent-match/mfe-intelligent-match/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09475832')) {
      api.createRecord('09475832', component.options)
    } else {
      api.reload('09475832', component.options)
    }
    module.hot.accept("./SortIcon.vue?vue&type=template&id=09475832", function () {
      api.rerender('09475832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SortIcon.vue"
export default component.exports